import React from "react";
import { Modal, FormControl, Button, FormGroup, ControlLabel } from "react-bootstrap";

export default class VersionMessageModalContainer extends React.Component {
    render() {
        return (
            <Modal show={this.props.show} onHide={this.props.onClosed}>
                <Modal.Header closeButton>
                    <Modal.Title>Please enter version message</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <p>{this.props.helpText}</p>
                    <FormGroup>
                        <ControlLabel>Version message</ControlLabel>
                        <FormControl
                            value={this.props.modalVersionMessage}
                            onChange={this.props.onModalVersionMessageChanged}
                        />
                    </FormGroup>
                </Modal.Body>
                <Modal.Footer>
                    <Button onClick={this.props.onClosed}>Cancel</Button>
                    <Button
                        bsStyle="primary"
                        onClick={this.props.onSaved}
                        disabled={this.props.modalVersionMessage.trim() === ""}
                    >
                        Save
                    </Button>
                </Modal.Footer>
            </Modal>
        );
    }
}
